<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">
            Última Execução
            {{ rotina ? rotina.titulo : "" }}
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-hover" style="margin-left: auto; margin-right: auto;">
            <thead>
            <tr>
              <th>Chave</th>
              <th>Valor</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="column in columns">
              <td>{{ column.label }}</td>
              <td style="word-wrap: break-word;">{{ column.value }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { yesNoRepresentation } from "@/helpers/transformers";
import {get} from "@/helpers/apiRequest";

export default {
  name: "UltimaRotina",
  props:[
    "rotina",
  ],
  data() {
    return {
      rotinaLog: {},
      columns: [],
      crons: {
        '* * * * *': 'A cada minuto',
        '*/2 * * * *': 'A cada 2 minutos',
        '*/3 * * * *': 'A cada 3 minutos',
        '*/4 * * * *': 'A cada 4 minutos',
        '*/5 * * * *': 'A cada 5 minutos',
        '*/6 * * * *': 'A cada 6 minutos',
        '*/7 * * * *': 'A cada 7 minutos',
        '*/8 * * * *': 'A cada 8 minutos',
        '*/9 * * * *': 'A cada 9 minutos',
        '*/10 * * * *': 'A cada 10 minutos',
        '*/15 * * * *': 'A cada 15 minutos',
        '*/20 * * * *': 'A cada 20 minutos',
        '*/30 * * * *': 'A cada 30 minutos',
        '0 */1 * * *': 'A cada 1 hora',
        '0 */2 * * *': 'A cada 2 horas',
        '0 */3 * * *': 'A cada 3 horas',
        '0 */4 * * *': 'A cada 4 horas',
        '0 */6 * * *': 'A cada 6 horas',
        '0 */12 * * *': 'A cada 12 horas',
        '0 0 * * *': 'Pontualmente à 0h',
        '0 1 * * *': 'Pontualmente à 1h',
        '0 2 * * *': 'Pontualmente às 2h',
        '0 3 * * *': 'Pontualmente às 3h',
        '0 4 * * *': 'Pontualmente às 4h',
        '0 5 * * *': 'Pontualmente às 5h',
        '0 6 * * *': 'Pontualmente às 6h',
        '0 7 * * *': 'Pontualmente às 7h',
        '0 8 * * *': 'Pontualmente às 8h',
        '0 9 * * *': 'Pontualmente às 9h',
        '0 10 * * *': 'Pontualmente às 10h',
        '0 11 * * *': 'Pontualmente às 11h',
        '0 12 * * *': 'Pontualmente às 12h',
        '0 13 * * *': 'Pontualmente às 13h',
        '0 14 * * *': 'Pontualmente às 14h',
        '0 15 * * *': 'Pontualmente às 15h',
        '0 16 * * *': 'Pontualmente às 16h',
        '0 17 * * *': 'Pontualmente às 17h',
        '0 18 * * *': 'Pontualmente às 18h',
        '0 19 * * *': 'Pontualmente às 19h',
        '0 20 * * *': 'Pontualmente às 20h',
        '0 21 * * *': 'Pontualmente às 21h',
        '0 22 * * *': 'Pontualmente às 22h',
        '0 23 * * *': 'Pontualmente às 23h',
      },
    }
  },
  methods: {
    fillColumns() {
      this.columns = [
        { label: "ID", value: this.rotina.id },
        { label: "Título", value: this.rotina.titulo },
        { label: "Descrição", value: this.rotina.descricao },
        { label: "Observação", value: this.rotina.observacao ?? "Sem observação" },
        { label: "Script", value: this.rotina.script },
        { label: "Ativo", value: yesNoRepresentation(this.rotina.ativo) },
        { label: "Modo", value: this.rotina.tipo_execucao === "M" ? "Manual" : "Automático" },
        { label: "Intervalo", value: this.rotina.tipo_execucao === "A" ? this.humanCron(this.rotina.cron) : "N/A" },
        { label: "Data de criação", value: this.rotina.datahora_criacao },
        { label: "Última alteração", value: this.rotina.datahora_atualizacao },
        { label: "Sucesso", value: this.rotinaLog?.sucesso != null ? yesNoRepresentation(this.rotinaLog.sucesso) : "N/A" },
        { label: "Mensagem", value: this.rotinaLog?.mensagem_retorno ?? "N/A" },
        { label: "Tempo de execução", value: this.rotinaLog?.tempo_execucao ? `${this.rotinaLog.tempo_execucao} seg` : "N/A" },
        { label: "Início", value: this.rotinaLog?.dthora_inicio ?? "N/A" },
        { label: "Fim", value: this.rotinaLog?.dthora_fim ?? "N/A" }
      ];
    },
    humanCron(cron) {
      return this.crons[cron] || cron;
    },
    getLogs(page = 1) {
      this.isFetching = true;
      this.errorMessage = null;

      get(`/admin/rotinas/log-execucao/${this.rotina.id}?page=${page}`)
        .then((response) => {
          this.rotinaLog = response.itens[0];
          this.fillColumns();
        })
        .catch((error) => this.errorMessage = error.message)
        .finally(() => {
          this.isFetching = false;
        })
    },
  },
  beforeMount() {
    this.getLogs(1);
  },
}
</script>

<style scoped>

</style>